import { ResourceType } from 'features/common/types'
import { IntlShape } from 'react-intl'
import { AlertSeverity, Notification } from 'features/notifications/state/notificationSlice'
import { NOTIFICATION_DURATION_IN_MS } from '@carto/meridian-ds/theme'

export const approvedNotification = (intl: IntlShape, resourceType: ResourceType): Notification => ({
  msg: intl.formatMessage(
    { id: 'collaboration.takeOverRequestDialog.approvedTitle' },
    { resourceType: intl.formatMessage({ id: `common.shareDialog.resourceTypes.${resourceType}` }) }
  ),
  type: AlertSeverity.Success,
  closeable: true
})

export const notificationDenied = (intl: IntlShape, user: string): Notification => ({
  msg: intl.formatMessage({ id: 'collaboration.takeOverRequestDialog.deniedTitle' }, { user }),
  formatted: false,
  type: AlertSeverity.Info,
  timeout: NOTIFICATION_DURATION_IN_MS * 2,
  closeable: true
})

export const switchedToViewerNotification = (intl: IntlShape, resourceType: ResourceType): Notification => ({
  msg: intl.formatMessage(
    { id: 'collaboration.takeOverResponseDialog.savedTitle' },
    { resourceType: intl.formatMessage({ id: `common.shareDialog.resourceTypes.${resourceType}` }) }
  ),
  type: AlertSeverity.Success,
  closeable: true
})
